module.exports = __webpack_public_path__ + "static/img/7.60c810f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/7.png
// module id = Dtlg
// module chunks = 0